// Single source of truth for Google Maps Platform credentials.
//
// These were previously hardcoded in 13 places (index.html, public/index.html
// and 11 components), which let the app-shell script and the page-level
// consumers drift onto DIFFERENT keys. That is exactly what broke the Geo
// Locator on 2026-08-21: the map ran on one key while VITE_GOOGLE_MAPS_MAP_ID
// belonged to another key's project, so the Map ID could not resolve and the
// Geocoder was denied. Import from here — never inline a key.
//
// Map IDs are project-scoped, so the key and the Map ID MUST come from the same
// GCP project. Keeping both in one module makes that pairing reviewable.
//
// Deliberately dependency-free: these constants are imported by leaf components
// and by tests, so this module must never pull in MUI, routes, or redux.

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '';

// True when a key is configured. Callers should render a configuration message
// rather than an empty map when this is false.
export const hasGoogleMapsApiKey = () => Boolean(GOOGLE_MAPS_API_KEY);

export default GOOGLE_MAPS_API_KEY;
